import config from 'src/config';
import { ResponseDto } from 'src/dtos/common/responseDto';
import { WmsOrderInPopupDto, WmsOrderOutPopupDto } from 'src/dtos/wmsOrder/wmsOrderDto';
import { getData } from 'src/utils/axios/serverHelper';

const baseUrl = `${config.apiUrl}/wmsOrder`;

export const getWmsOrderOutPopupList = async (searchText: string) => {
	return getData<ResponseDto<WmsOrderOutPopupDto[]>>(`${baseUrl}/modal/out`, {
		params: {
			searchText: searchText || '',
		},
	});
};

export const getWmsOrderInPopupList = async (searchText: string) => {
	return getData<ResponseDto<WmsOrderInPopupDto[]>>(`${baseUrl}/modal/in`, {
		params: {
			searchText: searchText || '',
		},
	});
};
